// If you want to pick and choose which modules to include, comment out the above Foundation import and uncomment
// the line below
//import './lib/foundation-explicit-pieces'

window.jQuery = window.$ = $;
$((event) => {
    require("./lib/leadcapture.js");

    $(document).foundation();

    const mHeigths = [
        ".promo-container",
        ".tactical-content",
        ".contact-container",
        ".staff",
        ".js-forms-content",
        ".blog-height",
        ".js-sitemap-height",
        ".js-sector-options",
        ".home-height-2",
        ".home-height-1",
        "js-headcol-mh",
    ];
    $.each(mHeigths, function (i, selector) {
        $(selector).matchHeight({
            property: "height",
        });
    });
    $("a#skip-content").on("click", function (e) {
        // Keyboard accessiblity skip to content
        e.preventDefault();
    });
    $(".read-more").on("click", function (e) {
        // Staff view more
        e.preventDefault();
        const $this = $(this),
            $summaryDiv = $this.parent().find(".summaryContent"),
            $fullDiv = $this.parent().find(".fullContent");
        if ($this.is(".open")) {
            $this.text("Read more");
            doContentSwap($fullDiv, $summaryDiv, $summaryDiv, 100);
        } else {
            doContentSwap($summaryDiv, $fullDiv, $summaryDiv, 300);
            $this.text("Read less");
        }
        $this.toggleClass("open");
        return false;
    });

    function doContentSwap($source, $destination, $animate, speed) {
        const text = $source.html(),
            height = $animate.height();
        $animate.height(height); //make sure it doesnt move before we animate
        $source.html($destination.html()); // do content swap
        $destination.html(text);
        let newHeight = 0;
        $animate.children().each(function (i, item) {
            newHeight += $(item).outerHeight();
        });
        const $match = $animate.parents(".staffrw").first();
        $animate.animate(
            {
                height: newHeight,
            },
            {
                duration: speed,
                complete: function () {
                    $animate.css("height", "auto");
                    $(".staff", $match).matchHeight({
                        property: "height",
                    });
                },
                step: function (now, fx) {
                    $(".staff", $match).matchHeight({
                        property: "height",
                    });
                },
            }
        );
    }
    if ($("table").hasClass("table-scrollable")) {
        $(".table-scrollable").wrap("<div class='table-scroll'></div>");
        $(".table-scroll").before(
            "<div class='table-tooltip hide-for-print hide-for-medium'><div class='icon-rotate'></div><div class='table-tooltip-content'>Rotate for best view or swipe horizontally to see all columns</div></div>"
        );
    }

    $(".js-main-menu").on("click", function () {
        // Menu button
        $(this).toggleClass("open");
        handleMenu(this);
        if ($("#login-menu").hasClass("expanded")) {
            $("#login-menu").removeClass("expanded");
            $("#login-menu").hide();
        }
    });
    $(".js-login-button").on("click", function () {
        // Login button view menu
        if ($("body").hasClass("menu-open")) {
            $("body").removeClass("menu-open");
            $("#mobile-menu").hide();
            $(".js-main-menu").removeClass("open");
        }
    });

    function handleMenu(obj) {
        const $obj = $(obj);
        if ($obj.is(".open")) {
            $("html,body").animate(
                {
                    scrollTop: 0,
                },
                500,
                function () {
                    $("body,header.header").addClass("menu-open");
                }
            );
        } else {
            $("body,header.header").removeClass("menu-open");
        }
    }
    // Custom checkbox look n feel
    $(".label_check input").parent("label").addClass("c_off");
    $(".label_check input:checked")
        .parent("label")
        .removeClass("c_off")
        .addClass("c_on");
    $(".label_check input:disabled").parent("label").addClass("disabled");
    $(".label_check input").on("change", function () {
        var _t = $(this);
        var label = _t.parent("label");
        $("input[name=" + _t.attr("name") + "]")
            .parent("label")
            .removeClass("r_off")
            .removeClass("r_on");
        if (this.checked) {
            label.addClass("c_on").removeClass("c_off");
        } else {
            label.removeClass("c_on").addClass("c_off");
        }
        if (_t.prop("disabled")) {
            label.addClass("disabled");
        } else {
            label.removeClass("disabled");
        }
    });
    $(".label_check input").on("focus", function () {
        $(this).closest("label").addClass("c_focus");
    });
    $(".label_check input").on("blur", function () {
        $(this).closest("label").removeClass("c_focus");
    });
    // Custom radio button look n feel
    $(".label_radio input").parent("label").addClass("r_off");
    $(".label_radio input:checked")
        .parent("label")
        .removeClass("r_off")
        .addClass("r_on");
    $(".label_radio input:disabled").parent("label").addClass("disabled");
    $(".label_radio input").change(function () {
        var _t = $(this);
        var label = _t.parent("label");
        $("input[name=" + _t.attr("name") + "]")
            .parent("label")
            .removeClass("r_off")
            .removeClass("r_on");
        if (this.checked) {
            label.addClass("r_on");
        } else {
            label.addClass("r_off");
        }
        if (_t.prop("disabled")) {
            label.addClass("disabled");
        } else {
            label.removeClass("disabled");
        }
    });
    $(".label_radio input").on("focus", function () {
        $(this).closest("label").addClass("r_focus");
    });
    $(".label_radio input").on("blur", function () {
        $(this).closest("label").removeClass("r_focus");
    });

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has("subscribed")) {
        if (urlParams.get("subscribed") == "true") {
            $(".f-lc__step-one").hide();
            $(".f-lc__step-two").show();
        } else if (urlParams.get("subscribed") == "false") {
            $(".f-lc__step-one").hide();
            $(".f-lc__step-three").show();
        }
    }
});
